import { getWithLocaleFallback } from "../../services/strapiApi";

/**
 * Récupère un produit spécifique par son slug
 */
export const fetchProductBySlug = async (slug) => {
  const result = await getWithLocaleFallback(
    `/products?filters[slug][$eq]=${slug}&populate[metaImage][fields][0]=url&populate[metaImage][fields][1]=formats&populate[heroComponent][populate]=image&populate[sections][populate][0]=image&populate[sections][populate][1]=gallery&populate[contentBlocks][populate]=image&populate[domaine][populate]=icon&populate[caseStudies][populate]=*&populate[useCases][populate][useCases][populate][icon][fields][0]=url&populate[useCases][populate][useCases][populate][icon][fields][1]=formats`
  );

  if (!result.ok) {
    return result;
  }

  const item = Array.isArray(result.data) ? result.data[0] : null;
  if (!item) {
    return {
      ok: false,
      reason: "NOT_FOUND",
      status: result.status,
      data: null,
      error: null,
    };
  }

  return { ...result, data: item };
};

/**
 * Récupère tous les produits
 */
export const fetchAllProducts = async ({ locale, fallbackLocale } = {}) => {
  const result = await getWithLocaleFallback(
    `/products?populate[metaImage][fields][0]=url&populate[metaImage][fields][1]=formats&populate[heroComponent][populate]=image&populate[sections][populate][0]=image&populate[sections][populate][1]=gallery&populate[contentBlocks][populate]=image&populate[domaine][populate]=icon&populate[caseStudies][populate]=*&populate[useCases][populate][useCases][populate][icon][fields][0]=url&populate[useCases][populate][useCases][populate][icon][fields][1]=formats`,
    { locale, fallbackLocale }
  );

  if (!result.ok) {
    return result;
  }

  return result;
};